export const ADD_BLOG = "ADD_BLOG";
export const GET_BLOG = "GET_BLOG";
export const UPDATE_BLOG = "UPDATE_BLOG";
export const ADD_POST = "ADD_POST";
export const GET_POSTS = "GET_POSTS";
export const DELETE_BLOG = "DELETE_BLOG";
export const DELETE_POSTS = "DELETE_POSTS";
export const CHANGE_STATUS = "CHANGE_STATUS";
export const GET_POST_BY_ID = "GET_POST_BY_ID";
export const UPDATE_POST = "UPDATE_POST";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";







